import Vue from 'vue'
import { login, getInfo, logout, byPhonenumLogin } from '@/api/login'
import { ACCESS_TOKEN } from '@/store/mutation-types'
import { welcome } from '@/utils/util'

const user = {
  state: {
    workType: '',
    teamId: '',
    userType: '',
    enterpriseId: '',
    enterpriseName: '',
    userId: '',
    token: '',
    name: '',
    welcome: '',
    avatar: '',
    roles: [],
    buttons: [], // 按钮权限
    info: {},
    lcStatus: 1 // 乐橙凭证 1：未过期 0：已过期
  },

  mutations: {
    setLcStatus (state, lcStatus) {
      state.lcStatus = lcStatus
    },
    SET_TOKEN: (state, token) => {
      state.token = token
    },
    SET_NAME: (state, { name, welcome }) => {
      state.name = name
      state.welcome = welcome
    },
    SET_AVATAR: (state, avatar) => {
      state.avatar = avatar
    },
    SET_ROLES: (state, roles) => {
      state.roles = roles
    },
    SET_INFO: (state, info) => {
      state.info = info
    },
    SET_BUTTONS: (state, buttons) => {
      state.buttons = buttons
    },
    SET_USERID: (state, userId) => {
      state.userId = userId
    },
    SET_ENTERPRISEID: (state, enterpriseId) => {
      state.enterpriseId = enterpriseId
    },
    SET_ENTERPRISENAME: (state, enterpriseName) => {
      state.enterpriseName = enterpriseName
    },
    SET_USERTYPE: (state, userType) => {
      state.userType = userType
    },
    SET_TEAMID: (state, teamId) => {
      state.teamId = teamId
    },
    SET_WORKTYPE: (state, workType) => {
      state.workType = workType
    }
  },

  actions: {
    // 登录
    Login ({ commit }, userInfo) {
      return new Promise((resolve, reject) => {
        login(userInfo)
          .then(response => {
            const result = response
            Vue.ls.set(ACCESS_TOKEN, result.token, 12 * 60 * 60 * 1000)
            commit('SET_TOKEN', result.token)
            resolve(response)
          })
          .catch(error => {
            reject(error)
          })
      })
    },
    LoginByPhone ({ commit }, userInfo) {
      return new Promise((resolve, reject) => {
        byPhonenumLogin(userInfo)
          .then(response => {
            const result = response
            Vue.ls.set(ACCESS_TOKEN, result.token, 12 * 60 * 60 * 1000)
            commit('SET_TOKEN', result.token)
            resolve(response)
          })
          .catch(error => {
            reject(error)
          })
      })
    },

    // 获取用户信息
    GetInfo ({ commit }) {
      return new Promise((resolve, reject) => {
        getInfo()
          .then(response => {
            const result = response
            if (result.roleIds) {
              commit('SET_ROLES', result.roleIds)
              commit('SET_BUTTONS', result.buttons)
              commit('SET_USERID', result.userId)
              commit('SET_INFO', result)
              commit('SET_ENTERPRISEID', result.enterpriseId)
              commit('SET_ENTERPRISENAME', result.enterpriseName)
              commit('SET_USERTYPE', result.userType)
              commit('SET_TEAMID', result.teamId)
              commit('SET_WORKTYPE', result.workType)
            } else {
              reject(new Error('getInfo: roles must be a non-null array !'))
            }
            // console.log(result)
            commit('SET_NAME', { name: result.userName, welcome: welcome() })
            commit('SET_AVATAR', result.avatar || '/avatar2.jpg')
            resolve(response)
          })
          .catch(error => {
            reject(error)
          })
      })
    },

    // 登出
    Logout ({ commit, state }) {
      return new Promise(resolve => {
        logout(state.token)
          .then(() => {
            resolve()
          })
          .catch(() => {
            resolve()
          })
          .finally(() => {
            commit('SET_TOKEN', '')
            commit('SET_ROLES', [])
            commit('SET_INFO', {})
            Vue.ls.remove(ACCESS_TOKEN)
          })
      })
    }
  }
}

export default user
